import { useState } from 'react';
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';
import { startSignIn } from '@/lib/auth/session';

export function SignInPage() {
  const t = useTranslations('pages.admin.sign-in');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSignIn = async () => {
    setError(null);
    setBusy(true);

    try {
      await startSignIn();
    } catch {
      setBusy(false);
      setError(t('error'));
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <Card className="w-full max-w-sm">
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t('subtitle')}</CardDescription>
        </CardHeader>
        <CardContent className="space-y-3">
          <Button type="button" onClick={handleSignIn} disabled={busy} className="w-full">
            {busy ? t('loading') : t('google')}
          </Button>
          {error !== null && <p className="text-base text-danger-600">{error}</p>}
        </CardContent>
      </Card>
    </main>
  );
}
